import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  ErrorBoundary, trEnv, Bootstrap, logger,
} from 'ion-lib';
import App from './page/App';
import { generatedStore } from './+config';
import './i18n';
import './assets/scss/bootstrap-iso.scss';

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { app } = await import('./config.local.json');
  const searchParams = new URLSearchParams(window.location.search);
  window.baseURL = searchParams.get('wls') || `${app.resource.data.hostname}${app.resource.data.pathname}`;
} else {
  window.baseURL = trEnv.queryBaseUrl + trEnv.ivvQueryPath;
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Bootstrap>
    <Provider store={generatedStore}>
      <ErrorBoundary log={(message, details) => logger('hausrat', message, details)} path="appDaten.errorBoundary">
        <App />
      </ErrorBoundary>
    </Provider>
  </Bootstrap>,
);
